import { useContext } from 'react';
import CommunityContext from '../context/CommunityContext';

const useCommunity = () => useContext(CommunityContext);

export default useCommunity;
